export default class OtherCostType {
    id = 1;
    name = '';
    countInPrice = true;
}
